import Slide from '@mui/material/Slide';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import * as React from 'react';

interface Props {
  window?: () => Window;
  children: React.ReactElement;
  threshold?: number;
}

export default function HideOnScroll(props: Props) {
  const { children, window, threshold } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    threshold: threshold || 100
  });
  console.log('hide on scrol', trigger);

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}
